const isProduction = process.env.NODE_ENV === 'production'

export const URL = isProduction ? 'https://m46-heimdall.herokuapp.com' : 'https://m46-heimdall-stage.herokuapp.com' // 'http://localhost:8080'
//
// Ugly solution, when more customers are using remote opener we need to get base URL and auth token to PMC from backend
export const PMC_URL = 'https://parkering.parkando.se/'
export const PMC_TOKEN = 'eyJhbGciOiJIUzI1NiJ9.e30.ef7MgIM23PKCI2vGVjk1k3Ou9Uv_gkG3bB4Fs2M7Njs'
